import React, { useEffect, useState } from "react";
import AlertPop from "./shared/AlertPop";
import DwellMarketText from "./shared/DwellMarketText";
import Pagination from "./shared/Pagination";
import SharedButton from "./shared/SharedButton";
import { app_url } from "./shared/Utils";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const UserRequest = ({ handlelogout, showLoader }) => {
  const islogged = localStorage.getItem("islogged");
  const { trackPageView, trackEvent } = useMatomo();

  const [filteredUsers, setFilteredUsers] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currPage, setCurrPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [alertMessage, setAlertMessage] = useState(null);
  const [model, setModel] = useState(false);
  const [delUser, setDelUser] = useState(null);

  const closeModel = () => {
    setModel(false);
    setDelUser(null);
  };

  const setAlert = (type) => {
    setShowAlert(type);
  };

  const setPage = (pageType) => {
    trackEvent({ category: "Pagination Arrow Clicked", action: "click-event" });
    if (pageType) {
      setCurrPage(currPage + 1);
    } else {
      setCurrPage(currPage - 1);
    }
  };

  const handlePageSizeChange = (e) => {
    trackEvent({ category: "Page Size Changed", action: "change-event" });
    setCurrPage(0);
    setPageSize(e.target.value);
  };

  const handleRequestUserClick = (user) => {
    trackEvent({ category: "Approve Button Clicked", action: "click-event" });
    fetch(`${app_url}account/approveuser`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${islogged}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user.email),
    })
      .then((response) => {
        if (response.status === 401) {
          handlelogout();
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.status === undefined) {
          setAlertMessage(data.DuplicateUserName[0]);
          setAlert("danger");
        } else {
          setAlertMessage(data.message);
          setAlert("success");
        }
        getAllUserRequests();
        showLoader(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        showLoader(false);
        setAlert("danger");
      });
  };

  const handleDeleteBtn = (user) => {
    trackEvent({
      category: "Delete User Button Clicked",
      action: "click-event",
    });
    setDelUser(user);
    setModel(true);
  };

  const handleRejectRequestUserClick = () => {
    trackEvent({ category: "Reject Button Clicked", action: "click-event" });
    fetch(`${app_url}account/rejectuserrequest`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${islogged}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(delUser.email),
    })
      .then((response) => {
        if (response) {
          setAlertMessage("User Deleted!");
          setAlert("success");
          showLoader(false);
          getAllUserRequests();
        } else {
          setAlertMessage("Something Went Wrong!");
          showLoader(false);
          setAlert("danger");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        showLoader(false);
        setAlert("danger");
      });

    setModel(false);
    setDelUser(null);
  };

  const getAllUserRequests = () => {
    showLoader(true);
    fetch(`${app_url}account/getrequestedusers/${currPage}/${pageSize}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${islogged}`,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          handlelogout();
        } else {
          return response.json();
        }
      })
      .then((data) => {
        showLoader(false);
        setFilteredUsers(data);
        setTotalPage(Math.ceil(data.count / pageSize));
      })
      .catch((error) => {
        console.error("Error:", error);
        showLoader(false);
      });
  };
  useEffect(() => {
    getAllUserRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currPage, pageSize]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(null);
    }, 3000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  useEffect(() => {
    trackPageView({
      documentTitle: "User Request Page",
      href: window.location.href,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showAlert === "success" ? (
        <AlertPop variant="success">
          <strong>
            <i className="fa fa-check alert-icon"></i> Success! {alertMessage}
          </strong>
        </AlertPop>
      ) : (
        ""
      )}

      {showAlert === "danger" ? (
        <AlertPop variant="danger">
          <strong>
            <i className="fa fa-close alert-icon"></i> {alertMessage}
          </strong>
        </AlertPop>
      ) : (
        ""
      )}
      <div className="header-heading">
        <div className="container">
          <DwellMarketText />
        </div>
      </div>
      <div className="mat-elevation-z8">
        <h2 className="text-center p-3 user-request">User Requests</h2>
        {filteredUsers?.users ? (
          <>
            <div className="user-table">
              <table
                className="mat-table cdk-table mat-sort dt-container"
                role="table"
              >
                <thead>
                  <tr role="row" className="mat-header-row cdk-header-row">
                    <th
                      className="t-left mat-table-sticky mat-table-sticky-border-elem-top"
                      style={{ minWidth: 60 }}
                    >
                      id
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top w-90">
                      First Name
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top w-90">
                      Last Name
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top w-120">
                      Phone Number
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Email
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top w-120">
                      Company Name
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top">
                      Comments
                    </th>
                    <th className="t-left mat-table-sticky mat-table-sticky-border-elem-top last">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers?.users?.map((user) => {
                    return (
                      <tr key={user.id} role="row" className="mat-row cdk-row">
                        <td className="t-left word-break">{user.id}</td>
                        <td className="t-left">{user.firstName}</td>
                        <td className="t-left">{user.lastName}</td>
                        <td className="t-left">{user.phoneNumber}</td>
                        <td className="t-left">{user.email}</td>
                        <td className="t-left">{user.companyName}</td>
                        <td className="t-left">{user.comments}</td>
                        <td className="t-left last">
                          <SharedButton
                            id={`accept-${user.id}`}
                            addClass="mat-focus-indicator mat-raised-button mat-button-base mat-primary"
                            btnName="Approve"
                            handleClick={() => handleRequestUserClick(user)}
                          />
                          <SharedButton
                            id={`reject-${user.id}`}
                            addClass="mat-focus-indicator mat-raised-button mat-button-base mat-primary btn-red"
                            btnName="Reject"
                            handleClick={() => handleDeleteBtn(user)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination
              currPage={currPage}
              totalPage={totalPage}
              setPage={setPage}
              count={filteredUsers?.count}
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          ""
        )}

        <div className={`delete-popup ${model ? "d-block" : "d-none"}`}>
          <div className="cdk-overlay-container">
            <div
              className="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"
              onClick={closeModel}
            ></div>
            <div className="cdk-global-overlay-wrapper">
              <div id="cdk-overlay-0" className="cdk-overlay-pane">
                <div className="mat-dialog-container" id="mat-dialog-0">
                  <div className="ng-star-inserted text-center">
                    <div className="cross">
                      <i className="fa fa-times-circle"></i>
                    </div>
                    <h2 className="mat-dialog-title" id="mat-dialog-title-0">
                      <strong>Are You Sure?</strong>
                    </h2>
                    <div className="mat-dialog-content">
                      <p>
                        Do you really want to delete this record? This process
                        cannot be undone.
                      </p>
                      <div className="btn-seperate">
                        <SharedButton
                          id="delete-submit"
                          addClass="btn-purple btn-red"
                          btnName="Delete"
                          handleClick={handleRejectRequestUserClick}
                        />
                        <SharedButton
                          id="cancel-btn"
                          addClass="cancel-btn"
                          btnName="Cancel"
                          handleClick={closeModel}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserRequest;
